export default {
  init() {
    this.showAllImages();
    // GOFAB-32: Use embedded api instead
    // this.initMap();
    this.openPopup();
    this.showings();
    this.copyLink();
  },
  showAllImages() {
    const $showAllImages = $('.show-images');
    const $imageWrapper = $('.images');
    if ($showAllImages.length)
      $showAllImages.on('click', function(e) {
        e.preventDefault();
        $imageWrapper.find('.slide').removeClass('hidden');
        $showAllImages.addClass('hidden');
      });
  },
  showings: function() {
    const $inputShowings = $('input[name="showing"]');
    $inputShowings.on('change', function() {
      const checkedInitial = !$(this).is(':checked');
      //Uncheck all
      $inputShowings.prop('checked', false);
      //Not checked initial and not checked now (handling unchecking)
      if (!checkedInitial && !$(this).is(':checked')) {
        $(this).prop('checked', true);
      }
    });
  },
  openPopup() {
    const openPopups = document.querySelectorAll('.open-popup');
    const popupWrapper = document.querySelector('.popup-wrapper');
    const popupClose = document.querySelector('.popup-close');
    const mainWrapper = document.querySelector('#main');
    openPopups.forEach((openPopup) => {
      if (openPopup && popupWrapper) {
        openPopup.addEventListener('click', (e) => {
          e.preventDefault();
          if (mainWrapper.dataset.aos) {
            delete mainWrapper.dataset.aos;
          }
          this.selectShowing();
          popupWrapper.classList.add('visible');
        });
      }
      if (popupClose && popupWrapper) {
        popupClose.addEventListener('click', (e) => {
          e.preventDefault();
          popupWrapper.classList.remove('visible');
        });
      }
    });
  },
  selectShowing() {
    const showingRadio = document.querySelectorAll('.showing-wrapper input[type="radio"]');
    const slotRadio = document.querySelectorAll('.showing input[type="radio"]');
    if (showingRadio.length > 0) {
      showingRadio[0].checked = true;

      showingRadio.forEach((checkbox) => {
        checkbox.addEventListener('change', (e) => {

          // Deselect all radio buttons.
          if (slotRadio.length > 0) {
            slotRadio.forEach((radio) => {
              radio.checked = false;
            })
          }
          // If checkbox is checked. Find first radio button that's not disabled and check it.
          if (e.target.parentElement.parentElement.querySelector('.showing input[type="radio"]:not([disabled])')) {
            e.target.parentElement.parentElement.querySelector('.showing input[type="radio"]:not([disabled])').checked = true;
          }
        });
      })
    }
    if (slotRadio.length > 0) {
      if (document.querySelector('.showing input[type="radio"]:not([disabled])')) {
        document.querySelector('.showing input[type="radio"]:not([disabled])').checked = true;
      }
      slotRadio.forEach((radio) => {
        radio.addEventListener('change', (e) => {

          // Uncheck all checkboxes on radio button change.
          if (showingRadio.length > 0) {
            showingRadio.forEach((checkbox) => {
              checkbox.checked = false;
            })
          }

          // Find first related checkbox and check it.
          if (e.target.parentElement.parentElement.parentElement.parentElement.querySelector('.showing-wrapper input[type="radio"]')) {
            e.target.parentElement.parentElement.parentElement.parentElement.querySelector('.showing-wrapper input[type="radio"]').checked = true;
          }
        });
      })
    }
  },
  initMap: function() {
    const mapObject = document.querySelector('#map-object');
    if (mapObject) {
      const lat = parseFloat(mapObject.dataset.lat);
      const lon = parseFloat(mapObject.dataset.lon);

      if (typeof google !== 'undefined') {
        const map = new google.maps.Map(document.getElementById('map-object'), {
          center: { lat: lat, lng: lon },
          zoom: 13,
        });

        const marker = new google.maps.Marker({
          position: { lat: lat, lng: lon },
          map: map,
          icon: {
            url: prekApiSettings.template_path + '/resources/images/map-marker.png',
            size: new google.maps.Size(29, 37),
            scaledSize: new google.maps.Size(29, 37),
          }
        });
      }
    }
  },
  copyLink: function() {
    const copyLink = document.querySelector('.copy-link');
    const tooltip = document.querySelector('.tooltip');
    if (copyLink) {
      copyLink.addEventListener('click', () => {
        const UrlInput = document.querySelector('#copy-url');
        UrlInput.value = window.location.href;
        UrlInput.select();
        try {
          document.execCommand('copy');
          tooltip.innerHTML = 'Länk kopierad!';
        } catch (err) {
          tooltip.innerHTML = 'Länken kopierades inte';
        }
        tooltip.classList.add('visible');
        setTimeout(() => {
          if (tooltip.classList.contains('visible')) {
            tooltip.classList.remove('visible');
          }
        }, 2000);
      })
    }
  }
};
